import { makeSpiderApiCall, makeNodeServiceCall } from './utils.es6';

export function getCareFinderProviders(query) {
	const queryString = new URLSearchParams(query).toString();
	return makeNodeServiceCall(`/phydir/carefinder?${queryString}`)
		.then((response) => response.data)
		.catch((err) => {
			// eslint-disable-next-line no-console
			console.log('CareFinder Provider fetch error', err);
			return {};
		});
}

export function getZipcodeSuggestions(queryparams) {
	return makeSpiderApiCall(
		`/search/2/api/lhd_geotypeahead?cache2=true&count=20&q=${queryparams.q}`,
	)
		.then((response) => response.data)
		.catch((err) => {
			// eslint-disable-next-line no-console
			console.log('CareFinder Geo fetch error', err);
		});
}
